"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ACCOUNT_TOKEN = void 0;
var ACCOUNT_TOKEN = exports.ACCOUNT_TOKEN = 'NPS-39ebd2f8';